module.exports = __webpack_public_path__ + "img/cloud_upload.bdb1f250.svg";